import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { Container, Row, Col } from "react-bootstrap";
import { healerServices } from "@/services/healerServices";
import Layout from "@/components/layout";
import SocialSignCard from '@/components/common/social-signin-card';
import CredentailSignCard from '@/components/common/credential-signin-card';
import ForgotPasswordCard from '@/components/common/forgot-password-card';
import ResetPasswordCard from '@/components/common/reset-password-card';
import SignUpCard from "@/components/common/social-signup";
import HealerCarousel from "@/components/healer/caraousel";
import styles from "@/styles/healer/HealerSignIn.module.css";
import signUpSvg from '../../../../public/images/signup.svg';
import updatedCalendarSvg from '../../../../public/images/updated-calendar.svg';
import bookAndPaySvg from '../../../../public/images/book-and-pay.svg';
import Head from 'next/head';
import Testimonial from "@/components/healer/testimonials";

function HealerSignIn(props) {
  const { asPath } = useRouter();
  const [pageState, setPageState] = useState(null);
  const userType = "healer";
  const [healersList, setHealersList] = useState(props?.healersList ?? []);
  const [healerSignIn, setHealerSignIn] = useState(props?.healerSignIn ?? []);
  const [healerSocialSignIn, setHealerSocialSignIn] = useState(props?.healerSocialSignIn ?? []);
  const [healerSocialSignUp, setHealerSocialSignUp] = useState(props?.healerSocialSignUp ?? []);
  const [healerForgotPassword, setHealerForgotPassword] = useState(props?.healerForgotPassword ?? []);

  const pageStateHandler = (val) => {
    setPageState(val);
  };

  //handler if url changed then compare state value and handle
  useEffect(() => {
    const pageManager = () => {
      let page;
      if (asPath.includes('healer/social/signin')) {
        page = 'socialSignIn';
      } else if (asPath.includes('healer/signin')) {
        page = 'credentialSignIn';
      } else if (asPath.includes('healer/forgot-password')) {
        page = 'forgotPassword';
      } else if (asPath.includes('healer/reset-password')) {
        page = 'resetPassword';
      } else {
        page = 'signUp';
      }

      return page;
    }

    const page = pageManager();
    if (page != pageState) {
      pageStateHandler(page);
    }
  }, [asPath]);

  return (
    <>
    {asPath.includes('healer/social/signin')?
    <Head>
        <title>{healerSocialSignIn?.meta?.og_title}</title>
        <meta name="title" content={healerSocialSignIn?.meta?.meta_title}></meta>
        <meta name="description" content={healerSocialSignIn?.meta?.meta_description}></meta>
        <meta name="keywords" content={healerSocialSignIn.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={healerSocialSignIn?.meta?.og_title}></meta>
        <meta property="og:image" content={healerSocialSignIn?.meta?.og_image}></meta>
        <link rel="canonical" href="https://www.zenkify.com/auth/healer/social/signin"></link>
        <meta property="og:description" content={healerSocialSignIn?.meta?.meta_description}></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={healerSocialSignIn?.meta?.meta_title} />
        <meta name="twitter:description" content={healerSocialSignIn?.meta?.meta_description}/>
        <meta name="twitter:image" content={healerSocialSignIn?.meta?.og_image} />
        <meta property="og:url" content="https://www.zenkify.com/auth/healer/social/signup" />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="zenkify healer social signup" />
        <meta property="og:image" content={healerSocialSignIn?.meta?.og_image}></meta>
        </Head>
        : asPath.includes('healer/signin') ?
        <Head>
        <title>{healerSignIn?.meta?.og_title}</title>
        <meta name="title" content={healerSignIn?.meta?.meta_title}></meta>
        <meta name="description" content={healerSignIn?.meta?.meta_description}></meta>
        <meta name="keywords" content={healerSignIn?.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={healerSignIn?.meta?.og_title}></meta>
        <meta property="og:image" content={healerSignIn?.meta?.og_image}></meta>
        <link rel="canonical" href="https://www.zenkify.com/auth/healer/signin"></link>
        <meta property="og:description" content={healerSignIn?.meta?.meta_description}></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={healerSignIn?.meta?.meta_title} />
        <meta name="twitter:description" content={healerSignIn?.meta?.meta_description}/>
        <meta name="twitter:image" content={healerSignIn?.meta?.og_image} />
        <meta property="og:url" content="https://www.zenkify.com/auth/healer/signin" />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="zenkify healer signin" />
        <meta property="og:image" content={healerSignIn?.meta?.og_image}></meta>
        </Head>:
        asPath.includes('healer/forgot-password')?
        <Head>
        <title>{healerForgotPassword?.meta?.og_title}</title>
        <meta name="title" content={healerForgotPassword?.meta?.meta_title}></meta>
        <meta name="description" content={healerForgotPassword?.meta?.meta_description}></meta>
        <meta name="keywords" content={healerForgotPassword?.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={healerForgotPassword?.meta?.og_title}></meta>
        <meta property="og:image" content={healerForgotPassword?.meta?.og_image}></meta>
        <meta property="og:description" content={healerForgotPassword?.meta?.meta_description}></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={healerForgotPassword?.meta?.meta_title} />
        <meta name="twitter:description" content={healerForgotPassword?.meta?.meta_description}/>
        <meta name="twitter:image" content={healerForgotPassword?.meta?.og_image} />
        <meta property="og:url" content="https://www.zenkify.com/auth/healer/forgot-password" />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="zenkify healer forgot password" />
        <meta property="og:image" content={healerForgotPassword?.meta?.og_image}></meta>
        </Head>
        :asPath.includes('healer/social/signup')?
        <Head>
        <title>{healerSocialSignUp?.meta?.og_title}</title>
        <meta name="title" content={healerSocialSignUp?.meta?.meta_title}></meta>
        <meta name="description" content={healerSocialSignUp?.meta?.meta_description}></meta>
        <meta name="keywords" content={healerSocialSignUp?.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={healerSocialSignUp?.meta?.og_title}></meta>
        <meta property="og:image" content={healerSocialSignUp?.meta?.og_image}></meta>
        <link rel="canonical" href="https://www.zenkify.com/auth/healer/social/signup"></link>
        <meta property="og:description" content={healerSocialSignUp?.meta?.meta_description}></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={healerSocialSignUp?.meta?.meta_title} />
        <meta name="twitter:description" content={healerSocialSignUp?.meta?.meta_description}/>
        <meta name="twitter:image" content={healerSocialSignUp?.meta?.og_image} />
        <meta property="og:url" content="https://www.zenkify.com/auth/healer/social/signup" />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="zenkify healer social signup" />
        <meta property="og:image" content={healerSocialSignUp?.meta?.og_image}></meta>
        </Head>
        :""
        }
      <section
        className={styles["customer-banner"]}
        style={{ backgroundImage: "url(/images/healing-banner.jpg)" }}
      >
        <Container>
          <Row>
            <Col sm={5} className="align-self-center">
              <div className={styles["leftside-banner-img"]}>
                <Image width={500} height={500} className="w-100" src="/images/banner-slider-2.png" alt="Reiki Healing Service" />
              </div>
            </Col>
            {
              (pageState == 'socialSignIn') ?
                <SocialSignCard pageStateHandler={(val) => pageStateHandler(val)} userType={userType} /> :
                (pageState == 'credentialSignIn') ?
                  <CredentailSignCard pageStateHandler={(val) => pageStateHandler(val)} userType={userType} /> :
                  (pageState == 'forgotPassword') ?
                    <ForgotPasswordCard pageStateHandler={(val) => pageStateHandler(val)} userType={userType} /> :
                    (pageState == 'resetPassword') ?
                      <ResetPasswordCard pageStateHandler={(val) => pageStateHandler(val)} userType={userType} /> :
                      <SignUpCard pageStateHandler={(val) => pageStateHandler(val)} userType={userType} />
            }
          </Row>
        </Container>
      </section>
<Testimonial />
      <section className={styles["bringfor-your"]}>
        <Container>
          <Row>
            <Col lg={8} className="m-auto">
              <div className="section-title">
                <h1 className="title">What Zenkify brings for you</h1>
                <h2>
                  Zenkify offers a comprehensive and convenient avenue to explore and benefit from the power of energy healing.It brings a transformative and empowering experience by connecting you with a diverse range of energy healing modalities and practitioners.
                </h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4} className={styles["tabcontent-customer"]}>
              <div className={styles["forcustomer-content"]}>
                <div className={styles["middle-image"]}>
                  <Image src={signUpSvg} alt="signup" />
                </div>
                <div className={styles["forcustomer-bottom"]}>
                  <h4>1. Create Zenkify Profile </h4>
                  <p>
                    It is easy to start with the transformative journey and be a part of Energy Healing Community by Simple Sign Up
                  </p>
                </div>
              </div>
            </Col>
            <Col md={4} className={styles["tabcontent-customer"]}>
              <div className={styles["forcustomer-content"]}>
                <div className={styles["middle-image"]}>
                  <Image src={updatedCalendarSvg} alt="signup" />
                </div>
                <div className={styles["forcustomer-bottom"]}>
                  <h4>2. Keep Updated Calendar </h4>
                  <p>
                    Zenkify allows you to update the calendar as per your availability ensuring flexibilty and feasibility to you.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={4} className={styles["tabcontent-customer"]}>
              <div className={styles["forcustomer-content"]}>
                <div className={styles["middle-image"]}>
                  <Image src={bookAndPaySvg} alt="signup" />
                </div>
                <div className={styles["forcustomer-bottom"]}>
                  <h4>3. Grow your Practice </h4>
                  <p>
                    With Zenkify you can provide hassel free Energy Healing services across the globe with minimal expense and wide outreach.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <HealerCarousel props={{ healersList }} />
    </>
  );
}

HealerSignIn.getLayout = function getLayout(page) {
  return (
    <Layout>{page}</Layout>
  )
}

export default HealerSignIn;

// ssr
export async function getServerSideProps() {
  const fetchHealersList = async () => {
    const res = await healerServices.getHealers();
    if (res.status) {
      return res.data;
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchHealerSignInMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("healer-sign-in");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const fetchHealerSocialSignInMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("healer-social-sign-in");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const fetchHealerSocialSignUpMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("healer-social-sign-up");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const fetchHealerForgotPasswordMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("healer-forgot-password");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const healersList = await fetchHealersList()??{};
  const healerSignIn = await fetchHealerSignInMeta()??{};
  const healerSocialSignIn = await fetchHealerSocialSignInMeta()??{};
  const healerSocialSignUp = await fetchHealerSocialSignUpMeta()??{};
  const healerForgotPassword = await fetchHealerForgotPasswordMeta()??{};

  // Pass data to the page via props
  return { props: { healersList, healerSignIn, healerSocialSignIn, healerSocialSignUp, healerForgotPassword } }
}
